import {Component, Input, OnInit} from '@angular/core';
import * as Highcharts from 'highcharts';
import {DataService} from '../data.service';

declare var require: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);

@Component({
  selector: 'app-chart-box',
  templateUrl: './chart-box.component.html',
  styleUrls: ['./chart-box.component.css']
})
export class ChartBoxComponent implements OnInit {

  private _optionsH;

  @Input()
  set optionsH(value: any) {
    this._optionsH = value || {};
    Highcharts.chart('chart-container', this._optionsH);
  }

  get optionsH(): any {
    return this._optionsH;
  }

  constructor(private dataService: DataService) {
  }

  ngOnInit() {

    Highcharts.setOptions({
      time: {
        useUTC: false
      }
    });

  }

  onCloseChart() {
    this.dataService.setChartOptions(null);
  }

}
